import { Component } from 'utils';

@Component({
    controllerAs: 'vm',
    template: require('./policyEngine.tpl.html')
})
export class PolicyEngineComponent {
    static $inject = ['store','$stateParams'];

     constructor(store,$stateParams) {
        this.store = store;
        this.projectId = $stateParams.id;
        this.envId = $stateParams.envID;

        this.unsubscribe = this.store.subscribe(() => {
            this.envDetail = this.store.getState().environments.envDetails;
        });

        this.$onDestroy = function () {
            this.unsubscribe();
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/policyEngine/policyEngine.js